import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=ba809048&"
import script from "./OrderHistory.vue?vue&type=script&lang=ts&"
export * from "./OrderHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports